<template>
  <section v-for="list in lists" :key="list.id" :class="{ '-home': isHome }">
    <router-link :to="'/news/detail/' + list.id">
      <div>
        <img
          v-if="list.thumbnail.url"
          :src="list.thumbnail.url"
          :alt="list.title.rendered"
        />
        <img
          v-else
          src="@/assets/images/common/noimg.jpg"
          :alt="list.title.rendered"
        />
      </div>
      <div>
        <time :datetime="list.date">{{ formatDate(list.date) }}</time>
        <h3>{{ list.title.rendered }}</h3>
      </div>
    </router-link>
  </section>
</template>

<script lang="ts">
// TODO: NewsListに置き換え
export default {
  name: 'NewsLists',
  props: {
    lists: {
      type: Array
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const formatDate = (date: string) => {
      const dt = new Date(date)
      const year = dt.getFullYear()
      const month = dt.getMonth() + 1
      const day = dt.getDate()

      return `${year}年${month}月${day}日`
    }

    return {
      formatDate
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

a {
  display: flex;
  // padding: 20px 0;
  padding: 25px 0;
}
section:not(:last-of-type) a {
  border-bottom: 1px solid var.$color-border-gray;
}

section.-home {
  @include mixins.media() {
    flex: 0 0 calc((100% - 70px) / 3);
    margin-top: 20px;
    margin-right: 35px;
    margin-bottom: 5px;

    &:nth-of-type(3n) {
      margin-right: 0;
    }

    a {
      border-bottom: none;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

div:first-of-type {
  min-width: 120px;
  // width: calc(240 / 375 * 100vw);
  max-width: 120px;
  margin-right: 18px;
}
// img {
//   width: 100%;
// }
time {
  display: block;
  color: #666;
  font-size: 1.2rem;
  line-height: 1;
  margin-bottom: 7px;
}
h3 {
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  @include mixins.media() {
    line-height: 1.79;
  }
}
</style>
